import styled from "styled-components";
import { focusOutline } from "styles/focus";

export const CopyToClipboardButton = styled.button`
  padding: 4px 6px 2px 0;
  border-radius: 2px;

  ${focusOutline}
`;
